import React, { Component } from 'react'
import { Modal, Col, Row } from 'react-bootstrap';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";

// NOTE: assumed backend operations — confirm/adjust names + input type with your API.
const ADD_EMPLOYEE_ROLE = gql`
  mutation($params: EmployeeRole) {
    addEmployeeRole(params: $params)
  }
`;

const UPDATE_EMPLOYEE_ROLE = gql`
  mutation($params: EmployeeRole) {
    updateEmployeeRole(params: $params)
  }
`;

class CreateRoleModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roleName: "",
            roleNameError: "",
            description: "",
            isAttendance: false,
            submitError: "",
            loadingSpinner: 0,
            saved: false,
        };
    }

    componentDidUpdate(prevProps) {
        // (re)initialise the form whenever the modal is opened — prefill in edit mode
        if (this.props.show === true && prevProps.show === false) {
            const role = this.props.role;
            this.setState({
                roleName: role ? (role.role_name || "") : "",
                description: role ? (role.description || "") : "",
                isAttendance: role ? !!role.is_attendance : false,
                roleNameError: "",
                submitError: "",
                loadingSpinner: 0,
                saved: false,
            });
        }
    }

    handleSubmit = async () => {
        if (this.state.roleName.trim() === "") {
            this.setState({ roleNameError: "Please enter a role name" });
            return;
        }

        const isEdit = !!(this.props.role && this.props.role.id);

        this.setState({ loadingSpinner: 1, submitError: "" });

        try {
            const params = {
                role_name: this.state.roleName.trim(),
                description: this.state.description.trim(),
                is_attendance: this.state.isAttendance ? 1 : 0,
                institute_id: parseInt(Cookies.get("institutionid")),
            };
            if (isEdit) {
                params.id = parseInt(this.props.role.id);
                params.updated_by = parseInt(Cookies.get("id"));
            } else {
                params.inserted_by = parseInt(Cookies.get("id"));
            }

            const { data } = await this.props.client.mutate({
                mutation: isEdit ? UPDATE_EMPLOYEE_ROLE : ADD_EMPLOYEE_ROLE,
                variables: { params },
            });

            const ok = data && (isEdit ? data.updateEmployeeRole : data.addEmployeeRole);
            if (ok) {
                this.setState({ loadingSpinner: 0, saved: true });
                if (this.props.onSaved) this.props.onSaved();
                setTimeout(() => {
                    this.props.onHide();
                }, 1000);
            } else {
                this.setState({ loadingSpinner: 0, submitError: `Could not ${isEdit ? "update" : "create"} role. Please try again.` });
            }
        } catch (error) {
            this.setState({
                loadingSpinner: 0,
                submitError: (error.graphQLErrors && error.graphQLErrors.map(x => x.message).join(", ")) || "Something went wrong.",
            });
        }
    };

    render() {
        const isEdit = !!(this.props.role && this.props.role.id);

        const FIN = {
            label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
            input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "9px 12px", fontSize: 14, color: "#1f2937", background: "#f9fafb", width: "100%", height: 44 },
            err: { color: "#dc2626", fontSize: 12, marginTop: 3, display: "block" },
            section: { background: "#fff", borderRadius: 12, padding: "20px 20px 8px", marginBottom: 16, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
            heading: { fontSize: 13, fontWeight: 700, color: "#0f172a", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "11px 34px", fontSize: 14, fontWeight: 600, cursor: "pointer" },
            req: { color: "#dc2626" },
        };

        // do not forward our custom `role`/`onSaved` props onto the DOM Modal
        const { role, onSaved, ...modalProps } = this.props;

        return (
            <Modal {...modalProps} size="md" aria-labelledby="create-role-modal" centered>
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#0f172a", display: "flex", alignItems: "center", gap: 9 }}>
                        <i className={isEdit ? "fal fa-user-edit" : "fal fa-user-tag"} style={{ color: "#7c3aed" }} />{isEdit ? "Edit Role" : "Create Role"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#F8FAFC", padding: "24px 24px 16px" }}>
                    <div style={FIN.section}>
                        <p style={FIN.heading}><i className="fal fa-id-badge" />Role Details</p>
                        <Row>
                            <Col lg={12} md={12} sm={12} className="mb-3">
                                <label style={FIN.label}>Role Name <span style={FIN.req}>*</span></label>
                                <input
                                    style={FIN.input}
                                    type="text"
                                    placeholder="e.g. Admin, Accountant, Front Office"
                                    maxLength={20}
                                    autoComplete="off"
                                    value={this.state.roleName}
                                    onChange={(e) => this.setState({ roleName: e.target.value, roleNameError: "", submitError: "" })}
                                />
                                {this.state.roleNameError ? <span style={FIN.err}>{this.state.roleNameError}</span> : null}
                            </Col>

                            <Col lg={12} md={12} sm={12} className="mb-3">
                                <label style={FIN.label}>Description</label>
                                <textarea
                                    style={{ ...FIN.input, height: 90, paddingTop: 9, resize: "vertical" }}
                                    placeholder="Optional — what this role is for"
                                    maxLength={100}
                                    autoComplete="off"
                                    value={this.state.description}
                                    onChange={(e) => this.setState({ description: e.target.value, submitError: "" })}
                                />
                            </Col>

                            <Col lg={12} md={12} sm={12} className="mb-2">
                                <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", margin: 0 }}>
                                    <input
                                        type="checkbox"
                                        style={{ width: 16, height: 16, cursor: "pointer" }}
                                        checked={this.state.isAttendance}
                                        onChange={(e) => this.setState({ isAttendance: e.target.checked, submitError: "" })}
                                    />
                                    <span style={{ fontSize: 13, fontWeight: 600, color: "#374151" }}>Attendance</span>
                                </label>
                            </Col>

                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: "none", justifyContent: "flex-end", flexDirection: "column", alignItems: "flex-end" }}>
                    {this.state.saved ? (
                        <p style={{ color: "#059669", fontWeight: 600, marginBottom: 10 }}>Role {isEdit ? "Updated" : "Created"} Successfully</p>
                    ) : this.state.submitError ? (
                        <p style={{ color: "#dc2626", marginBottom: 10 }}>{this.state.submitError}</p>
                    ) : null}
                    <button type="button" style={FIN.btnPrimary} onClick={this.handleSubmit}>
                        {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-save" />}
                        {isEdit ? "Update Role" : "Create Role"}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withApollo(CreateRoleModal);
